import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // You can modify the request here before it's sent to the server
    // For example, you can add authorization headers or handle error responses

    // Clone the request to modify it
    const token = this.auth.getToken();
    const modifiedReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token)
    });

    // Pass the modified request to the next handler
    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle error responses here
        console.error('Error occurred:', error);
        // You can also throw the error to propagate it to the subscriber
        return throwError(error);
      })
    );
  }
}
